import React, { useMemo, useState } from "react";
import BlogSlider from "./BlogTopList";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import { Link } from "react-router-dom";

// IMPORT ALL BLOG IMAGES
// BLOG LIST IMAGES (CARD IMAGES)
import centralizedVsDecentralizedCryptoImg from "../../images/blog/blogs/Centralized vs Decentralized Crypto Exchanges_ Which One Should You Build (2).png";
import cryptoPoweredMarketingImg from "../../images/blog/blogs/Crypto-Powered Marketing_ Smarter Campaigns, Better ROI.png";
import exploreSmartAiSolutionsImg from "../../images/blog/blogs/Explore Our Smart AI Solutions in Blockchain for the Future of Business (2).png";
import businessesUsingBlockchainImg from "../../images/blog/blogs/How Businesses Are Using Blockchain Technology to Reduce Costs & Increase Trust.png";
import nftMarketplaceGuideImg from "../../images/blog/blogs/How to Build an NFT Marketplace_ Features, Cost & Development Process (2).png";

import centralizedVsDecentralizedExchangeImg from "../../images/blog/blogs/Centralized vs Decentralized Crypto Exchanges_ Which One Should You Build.png";

import cryptoMarketingRoiImg from "../../images/blog/blogs/Crypto-Powered Marketing_ Smarter Campaigns, Better ROI.png";

import smartAiBlockchainImg from "../../images/blog/blogs/Explore Our Smart AI Solutions in Blockchain for the Future of Business.png";

import blockchainCostReductionImg from "../../images/blog/blogs/How Businesses Are Using Blockchain Technology to Reduce Costs & Increase Trust.png";

import nftMarketplaceDevelopmentImg from "../../images/blog/blogs/How to Build an NFT Marketplace_ Features, Cost & Development Process.png";

const Icons = {
  arrow: (
    <>
      <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
        <rect x="3.783" y="13.463" width="14.31" height="1.817" transform="rotate(-40.2798 3.783 13.463)" fill="white" />
        <rect x="5.807" y="4.605" width="1.817" height="1.817" transform="rotate(-40.2798 5.807 4.605)" fill="white" />
        <rect x="8.367" y="4.816" width="1.817" height="1.817" transform="rotate(-40.2798 8.367 4.816)" fill="white" />
        <rect x="10.926" y="5.028" width="1.817" height="1.817" transform="rotate(-40.2798 10.926 5.028)" fill="white" />
        <rect x="13.277" y="7.8" width="1.817" height="1.817" transform="rotate(-40.2798 13.277 7.8)" fill="white" />
        <rect x="13.066" y="10.361" width="1.817" height="1.817" transform="rotate(-40.2798 13.066 10.361)" fill="white" />
        <rect x="12.855" y="12.922" width="1.817" height="1.817" transform="rotate(-40.2798 12.855 12.922)" fill="white" />
      </svg>

      <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
        <rect x="3.783" y="13.463" width="14.31" height="1.817" transform="rotate(-40.2798 3.783 13.463)" fill="white" />
        <rect x="5.807" y="4.605" width="1.817" height="1.817" transform="rotate(-40.2798 5.807 4.605)" fill="white" />
        <rect x="8.367" y="4.816" width="1.817" height="1.817" transform="rotate(-40.2798 8.367 4.816)" fill="white" />
        <rect x="10.926" y="5.028" width="1.817" height="1.817" transform="rotate(-40.2798 10.926 5.028)" fill="white" />
        <rect x="13.277" y="7.8" width="1.817" height="1.817" transform="rotate(-40.2798 13.277 7.8)" fill="white" />
        <rect x="13.066" y="10.361" width="1.817" height="1.817" transform="rotate(-40.2798 13.066 10.361)" fill="white" />
        <rect x="12.855" y="12.922" width="1.817" height="1.817" transform="rotate(-40.2798 12.855 12.922)" fill="white" />
      </svg>
    </>
  ),
};

// Unified data source (tags used for sidebar categories)
const allBlogs = [
  {
    img: exploreSmartAiSolutionsImg,
    imgHero: smartAiBlockchainImg,
    tag: "AI Blockchain",
    title: "Explore Our Smart AI Solutions in Blockchain for the Future of Business",
    content:
      "Discover how AI-powered blockchain solutions enable secure, adaptive, and future-ready digital ecosystems.",
    link: "/Explore Our Smart AI Solutions in Blockchain for the Future of Business",
  },
  {
    img: businessesUsingBlockchainImg,
    imgHero: blockchainCostReductionImg,
    tag: "Blockchain",
    title: "How Businesses Are Using Blockchain Technology to Reduce Costs & Increase Trust",
    content:
      "Blockchain eliminates intermediaries, reduces fraud, and builds transparency across business operations.",
    link: "/How Businesses Are Using Blockchain Technology to Reduce Costs & Increase Trust",
  },
  {
    img: nftMarketplaceGuideImg,
    imgHero: nftMarketplaceDevelopmentImg,
    tag: "NFT Marketplace",
    title: "How to Build an NFT Marketplace: Features, Cost & Development Process",
    content:
      "A complete guide to NFT marketplace features, development workflow, technology stack, and cost factors.",
    link: "/How to Build an NFT Marketplace: Features, Cost & Development Process",
  },
  {
    img: centralizedVsDecentralizedCryptoImg,
    imgHero: centralizedVsDecentralizedExchangeImg,
    tag: "Crypto Exchange",
    title: "Centralized vs Decentralized Crypto Exchanges: Which One Should You Build?",
    content:
      "Compare CEX and DEX models based on liquidity, security, compliance, cost, and scalability.",
    link: "/Centralized vs Decentralized Crypto Exchanges: Which One Should You Build?",
  },
  {
    img: cryptoPoweredMarketingImg,
    imgHero: cryptoMarketingRoiImg,
    tag: "Crypto Marketing",
    title: "Crypto-Powered Marketing: Smarter Campaigns, Better ROI",
    content:
      "Leverage blockchain, smart contracts, and tokenized rewards to run transparent, high-ROI marketing campaigns.",
    link: "/Crypto-Powered Marketing: Smarter Campaigns, Better ROI",
  },
];

const BlogList: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);

  const itemsPerPage = 3;

  const filteredBlogs = useMemo(
    () => (categoryFilter ? allBlogs.filter((b) => b.tag === categoryFilter) : allBlogs),
    [categoryFilter]
  );

  const totalPages = Math.ceil(filteredBlogs.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const paginatedBlogs = filteredBlogs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  React.useEffect(() => {
    setCurrentPage(1);
  }, [categoryFilter]);

  return (
    <div>
      <BlogSlider blogs={allBlogs} />
      <section className="blog_details_section pt-120">
        <div className="container">
          <div className="row mt-none-50 g-0 align-items-start">
            <div className="col-lg-8 mt-50">
              <div className="blog_details_content">

                {/* ITEM 1 */}
                {paginatedBlogs[0] && (
                  <div className="blog_details_item img-hove-effect ul_li xb-border">
                    <div className="xb-item--img xb-img pt-2">
                      {[1, 2, 3, 4].map((i) => (
                        <Link key={i} to={paginatedBlogs[0].link}>
                          <img src={paginatedBlogs[0].img} alt="" />
                        </Link>
                      ))}
                    </div>

                    <div className="xb-item--holder">
                      <span className="xb-item--tag">#{paginatedBlogs[0].tag}</span>

                      <h3 className="xb-item--title border-effect-2">
                        <Link to={paginatedBlogs[0].link}>
                          {paginatedBlogs[0].title}
                        </Link>
                      </h3>

                      <span className="xb-item--content">
                        {paginatedBlogs[0].content}
                      </span>

                      <div className="xb-item--button mt-40">
                        <Link className="thm-btn agency-btn" to={paginatedBlogs[0].link}>
                          <span className="text">Read more</span>
                          <span className="arrow">
                            <span className="arrow-icon">{Icons.arrow}</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                {/* ITEM 2 */}
                {paginatedBlogs[1] && (
                  <div className="blog_details_item xb-border">
                    <div className="xb-item--inner">
                      <span className="xb-item--tag">#{paginatedBlogs[1].tag}</span>

                      <h3 className="xb-item--title border-effect-2">
                        <Link to={paginatedBlogs[1].link}>
                          {paginatedBlogs[1].title}
                        </Link>
                      </h3>

                      <span className="xb-item--content">
                        {paginatedBlogs[1].content}
                      </span>

                      <div className="xb-item--button mt-40">
                        <Link className="thm-btn agency-btn" to={paginatedBlogs[1].link}>
                          <span className="text">Read more</span>
                          <span className="arrow">
                            <span className="arrow-icon">{Icons.arrow}</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                {/* ITEM 3 */}
                {paginatedBlogs[2] && (
                  <div className="blog_details_item img-hove-effect ul_li xb-border">
                    <div className="xb-item--img xb-img">
                      {[1, 2, 3, 4].map((i) => (
                        <Link key={i} to={paginatedBlogs[2].link}>
                          <img src={paginatedBlogs[2].img} alt="" />
                        </Link>
                      ))}
                    </div>

                    <div className="xb-item--holder">
                      <span className="xb-item--tag">#{paginatedBlogs[2].tag}</span>

                      <h3 className="xb-item--title border-effect-2">
                        <Link to={paginatedBlogs[2].link}>
                          {paginatedBlogs[2].title}
                        </Link>
                      </h3>

                      <span className="xb-item--content">
                        {paginatedBlogs[2].content}
                      </span>

                      <div className="xb-item--button mt-40">
                        <Link className="thm-btn agency-btn" to={paginatedBlogs[2].link}>
                          <span className="text">Read more</span>
                          <span className="arrow">
                            <span className="arrow-icon">{Icons.arrow}</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                {/* EXTRA ITEMS */}
                {paginatedBlogs.length > 3 &&
                  paginatedBlogs.slice(3).map((item, idx) => (
                    <div key={`extra-${idx}`} className="blog_details_item xb-border">
                      <div className="xb-item--inner">
                        <span className="xb-item--tag">#{item.tag}</span>

                        <h3 className="xb-item--title border-effect-2">
                          <Link to={item.link}>{item.title}</Link>
                        </h3>

                        <span className="xb-item--content">
                          {item.content}
                        </span>

                        <div className="xb-item--button mt-40">
                          <Link className="thm-btn agency-btn" to={item.link}>
                            <span className="text">Read more</span>
                            <span className="arrow">
                              <span className="arrow-icon">{Icons.arrow}</span>
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}

                {/* PAGINATION */}
                <ul className="blog-pagination ul_li">
                  <li>
                    <Link className="xb-border" to="#"
                      onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1); }}>
                      <i className="fas fa-chevron-double-left"></i>
                    </Link>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => (
                    <li key={i} className={currentPage === i + 1 ? "active" : ""}>
                      <Link className="xb-border" to="#"
                        onClick={(e) => { e.preventDefault(); handlePageChange(i + 1); }}>
                        {i + 1}
                      </Link>
                    </li>
                  ))}

                  <li>
                    <Link className="xb-border" to="#"
                      onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1); }}>
                      <i className="fas fa-chevron-double-right"></i>
                    </Link>
                  </li>
                </ul>

              </div>
            </div>

            <BlogSidebar blogData={allBlogs} setCategoryFilter={setCategoryFilter} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogList;
